import { useEffect } from "react";
import { Instagram } from "lucide-react";
import { INSTAGRAM_URL } from "./data";

const InstagramStrip = () => {
  useEffect(() => {
    if (document.querySelector('script[src*="widgets.sociablekit.com"]')) return;
    const s = document.createElement("script");
    s.src = "https://widgets.sociablekit.com/instagram-feed/widget.js";
    s.defer = true;
    document.body.appendChild(s);
  }, []);

  return (
    <section
      data-testid="instagram-strip"
      className="overflow-hidden border-b-2 border-ink bg-ink py-10"
    >
      <a
        href={INSTAGRAM_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="instagram-strip-link"
        className="group mb-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 px-4 text-center text-paper"
      >
        <Instagram size={20} className="text-polered" />
        <span className="font-display text-2xl uppercase tracking-wide">
          @oliversbarbershop
        </span>
        <span className="font-hand text-lg text-paper/60">
          — fresh cuts in your feed
        </span>
      </a>
      <div className="mx-auto max-w-[1500px] px-4 sm:px-6">
        <div className="border-2 border-paper bg-paper p-3 shadow-hard-paper sm:p-5">
          <div
            className="sk-instagram-feed"
            data-embed-id="25711201"
            data-testid="instagram-widget"
          ></div>
        </div>
      </div>
    </section>
  );
};

export default InstagramStrip;
